import {Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

import {ProjectedPerformance} from '../../../../shared/models/ProjectedPerformance.model';
import InvestmentType from '../../../../shared/enums/InvestmentType.enum';
import { isNullOrUndefined } from 'src/app/shared/TerraUtils';
import HoldingDiscriminator from '../../../../shared/enums/HoldingDiscriminator.enum';

@Component({
  selector: 'terra-holding-investment-performance',
  templateUrl: './holding-investment-performance.component.html',
  styleUrls: ['./holding-investment-performance.component.scss']
})
export class HoldingInvestmentPerformanceComponent implements OnInit {
  @Input() cumulativeProjectedPerformance: ProjectedPerformance;
  @Input() holdingDiscriminator: HoldingDiscriminator;
  @Input() isGpPreview = false;

  // enums
  HoldingDiscriminator = HoldingDiscriminator;

  // Consts
  InvestmentType = InvestmentType;
  isNullOrUndefined = isNullOrUndefined;

  displayDetails$ = new BehaviorSubject(true);

  constructor() { }

  ngOnInit(): void {
  }

  numberOfBullets() {
    if (!this.cumulativeProjectedPerformance) {
      return 0;
    }
    const displayedBullets = ['cashOnCashRate', 'nonLeveragedCapRate', 'targetInvestmentIrr', 'expectedRoi', 'targetEquityMultiplier', 'preferredReturn', 'targetInvestmentPeriod'];

    const count = Object.keys(this.cumulativeProjectedPerformance)
      .filter(k => displayedBullets.includes(k) && this.cumulativeProjectedPerformance[k] !== null).length;

    if (count === 0) {
      this.displayDetails$.next(false);
    }

    return count;
  }
}
